import React from 'react';

export type MultiselectBadgesBlockProps = {
  id: string; // id used for aria-labelledby
  title: string;
  options: string[];
  selected: string[];
  onToggle: (option: string) => void;
};

/**
 * MultiselectBadgesBlock
 * Renders a titled section with a list of selectable badge-like buttons (chips)
 * that support multi-selection via an onToggle callback.
 *
 * It preserves the same structure/classes/ARIA attributes used in CoursesFilter.
 */
const MultiselectBadgesBlock: React.FC<MultiselectBadgesBlockProps> = ({ id, title, options, selected, onToggle }) => {
  return (
    <div className="cf-section" role="group" aria-labelledby={id}>
      <div id={id} className="cf-section-title">{title}</div>
      <div className="cf-chips" role="listbox" aria-multiselectable="true">
        {options.map(opt => {
          const active = (selected ?? []).includes(opt);
          return (
            <button
              key={opt}
              type="button"
              role="option"
              aria-selected={active}
              className={"cf-chip" + (active ? " active" : "")}
              onClick={() => onToggle(opt)}
            >
              {opt}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default MultiselectBadgesBlock;
